import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';
import { Route, Switch } from 'react-router-dom';
import MyAppPool from '../AppPool';
import { lng } from '../ulanguages/language';
import { convertDataToShowable, getImgAddress, getRouteParamAtIndex, getSiteShortName } from '../util/text';
import { musicFastResourceType, contentTypeToFastType, isSet } from '../util/typeu';
import BannerReaction from '../view_component/BannerReaction';
import BreadCumbs from '../view_component/BreadCumbs';
import CapaSection from '../view_component/CapaSection';
import Erro404 from '../view_component/Erro404';
import SkeletonBlock from '../view_component/SkeletonBlock';
import SubNavigation from '../view_component/SubNavigation';
import TextContentBox from '../view_component/TextContentBox';
import { isMobile } from './../util/mobile';
import { getCurrentUrl, isServer } from './../util/windowUtil';
import CSSTransition2 from './../view_component/CSSTransition2';
import MusicGeralView from './musicsub/MusicGeralView';
import ContentBannerSetter from '../view_component/ContentBannerSetter';
import { serverRegisterFetch } from '../util/updateManager';
import ResourceMediaView from "./resourceMedia";
import './music.css';
import { getYoutubeThumbnail } from '../util/youtube';
import TabbedContent from '../view_component/TabbedContent';
import Capa from './../view_component/Capa';
import CycleBanner from '../view_component/CycleBanner';

function vhToPixels (vh) {
  if (!isServer())
    return Math.round(window.innerHeight / (100 / vh)) + 'px';
  return '1080px';
}

@observer
class Music extends Component {
  constructor(props)
  {
    super(props);
    this.state={currentMusic:-1}
    serverRegisterFetch(Music.getInitialValues);
  }
  componentDidMount()
  {
    Music.getInitialValues();
  }
  static async getInitialValues()
  {
    let musicid = getRouteParamAtIndex(getCurrentUrl(),2);
    //console.log("COMPANY::::",musicid);
    if (isSet(musicid) || musicid===0)
    {
      //console.log("COMPANY FETCH::::",musicid);
      let p1 = MyAppPool.cMusic.fetchMusicById(musicid);
      let p3 = MyAppPool.cReactionPosts.fetchReactionPosts(contentTypeToFastType('music'),musicid);
      await Promise.all([p1,p3]);
    }
    return Promise.resolve();
  }
  componentWillReceiveProps()
  {
    let musicid = getRouteParamAtIndex(getCurrentUrl(),2);
    let {currentMusic}= this.state;
    if (currentMusic!==musicid)
    {
      this.setState({currentMusic:musicid});
      Music.getInitialValues();
    }
  }

  addToCurrentPlayList = () =>
  {
    let current = MyAppPool.cMusic.currentMusicPage;
    if (!current.ready)
        return;
    let playItem = {
        title: current.name,
        band: current.band,
        where: '',
        ytid: current.videourl,
        id:current.id};
    MyAppPool.cMusic.addToPlayQueue(playItem);
    
  }

  play = ()=>
  {
    let current = MyAppPool.cMusic.currentMusicPage;
    if (!current.ready)
        return;
    let playItem = {
        title: current.name,
        band: current.band,
        where: '',
        ytid: current.videourl,
        id:current.id};
      MyAppPool.cMusic.addToPlayQueue(playItem);
      MyAppPool.cMusic.playMusicObject(playItem);
  }

  render(){
    let musicid = getRouteParamAtIndex(getCurrentUrl(),2);
    if (isNaN(Number(musicid)))
      return <Erro404 />;
    if (MyAppPool.session.musicFetchEmpty[musicid]===true)
      return <Erro404/>;
    let current = MyAppPool.cMusic.currentMusicPage;
    let tabBaseUrl = current.baseUrl;
    let tabs = [
      {name:lng('Geral'),url:tabBaseUrl}
    ];

    let lists = [];
    let listPresence = [];
    let reactionPosts = [];
    let reactionReady = 0;
    let resourceType = contentTypeToFastType('music');
    if (current.ready)
    {
      reactionPosts = MyAppPool.session.reactionPost[resourceType][current.id];
      if (typeof reactionPosts ==='undefined')
        {
          reactionPosts=[];
          reactionReady = 0;
        }else
          reactionReady = 1;
        lists = MyAppPool.session.user.lists[resourceType];
        listPresence = MyAppPool.cLists.getListPresence(resourceType,current.id);
        if (!Array.isArray(lists))
          lists = [];
    }
    
    
    let meta = {title:lng('Musica')+' | '+getSiteShortName()+'',desc:'',img:'',imgwidth:'',imgheight:'',imgtype:'',keywords:''};
   
    if (current.ready)
    {
      let desc = current.name +' - ' + current.otherTitles + " - "+current.band + " - "+  lng('Musica') ;
      meta =  {
        title:current.name +' - ' + current.otherTitles + " - "+current.band + " - "+  lng('Musica') + ' | '+getSiteShortName()+'',
        desc:desc,
        keywords:current.name +  ', ' + current.otherTitles +', ' +current.remainingTitles +', ' +current.band,
        img:current.mainimg,
        imgwidth:'320',
        imgheight:'180',
        imgtype:'png'
      };
    }
    let bannerImages = [];

    let baseImage = ['random:sky'];
    let bannerModes = ['bg'];
    let useCapa = false;
    if (current.ready && current.empty==false)
    {
        for(let i=0;i<current.anime.length;i++)
        {
          let anime = current.anime[i];
          if (isSet(anime.bannerimg) && anime.bannerimg.length>0)
          {
              bannerImages.push({image:getImgAddress(anime.bannerimg), url:anime.directUrl});
          }
        }
        let img = getYoutubeThumbnail(current.videourl);
        meta.img = img;
        current.mainimg=img;
        baseImage = ['random:sky',img];
        bannerModes = ['bg','capa'];
    }
    
    if (bannerImages.length>0)
    {
      baseImage = ["component:"+current.name+bannerImages.length];
      bannerModes = ['component'];
      useCapa=true;
    }
    //console.log("LOOK:",baseImage,bannerModes);

    if (current.empty)
      return <Erro404/>;
  
      return (
        <div>
          <Helmet>
            <title>{meta.title}</title>
            <meta name="title" content={meta.title} />
            <meta name="description" content={meta.desc} />
            <meta name="keywords" content={meta.keywords}/>
            <meta property="og:type" content="website" />
            <meta property="og:title" content={meta.title} />
            <meta property="og:description" content={meta.desc} />
            <meta name="twitter:title" content={meta.title}/>
            <meta name="twitter:description" content={meta.desc}/>
            <meta name="twitter:image:src" content={getImgAddress(meta.img)}/>
            <meta property="og:image" content={getImgAddress(meta.img)} />
            <meta property="og:image:type" content={meta.imgtype}/>
            <meta property="og:image:width" content={meta.imgwidth}/>
            <meta property="og:image:height" content={meta.imgheight}/> 
          </Helmet>
        <div className="contentpage">
        <ContentBannerSetter images={baseImage} modes = {bannerModes} component=
        {<CycleBanner images={bannerImages}/>}   />
          <div>
          {!isMobile.any?
          <div style={{position:'relative'}}>
            <div className="reactions">
              <BannerReaction
                items ={reactionPosts}
                ready={reactionReady}
              />
            </div>
          </div>
          : <></>}
          </div>
          <div className='uk-flex uk-flex-row topsection'>
            {!isMobile.any?
            <div className="capa_left_column">
            <Capa ready={current.ready} img={current.mainimg}/>
            <CapaSection ready={current.ready} img={getImgAddress(current.mainimg,'/imgs/defaults/music.webp')}
            resourceType={contentTypeToFastType('music')}
            resourceId={current.id}
            lists={lists}
            listsPresence ={listPresence}
            gradeable={true}
            /> </div>
            :<></>
            }
            <div className="contentInfo">
            {isMobile.any?
            <div style={{"width":"100%"}}>
            {useCapa?<Capa ready={current.ready} img={current.mainimg}/>:<></>}
            <CapaSection ready={current.ready} img={current.mainimg} 
            resourceType={contentTypeToFastType('music')}
            resourceId={current.id}
            lists={lists}
            listsPresence ={listPresence}
            gradeable={true} /> </div>
            :<></>
            }
              <BreadCumbs/>
              {current.ready ?
               <>
                <h1 className="smallerheading"> <span id='title'>{current.name} &nbsp;</span>
                </h1>
                <h2 className="smallerheading2"> {current.otherTitles + " - "+current.band}</h2>
                <div className="flexDrop">
                {current.videourl!=='' && isSet(current.videourl)?
                [
                <button onClick={this.play} class="youtube-button" data-uk-tooltip={lng("Tocar")} ><i class="far fa-play-circle"></i></button>,
                <button onClick={this.addToCurrentPlayList} class="youtube-button" data-uk-tooltip={lng("Adicionar à fila de reprodução")}> +<i className="fas fa-stream"></i></button>
                ]
                :<></>} 
                {current.spotify!=='' && isSet(current.spotify)?
                <a target="_blank" href={current.spotify} class="spotify-button" data-uk-tooltip={lng("Tocar no Spotify")}> <i className="fab fa-spotify"></i></a>
                :<></>} 
                {current.apple!=='' && isSet(current.apple)?
                <a target="_blank" href={current.apple} class="apple-music-button" data-uk-tooltip={lng("Tocar na Apple Music")}> <i className="fab fa-apple"></i></a>
                :<></>}
                {current.amazon!=='' && isSet(current.amazon)?
                <a target="_blank" href={current.amazon} class="amazon-music-button" data-uk-tooltip={lng("Tocar na Amazon Music")} > <i className="fab fa-amazon"></i></a>
                :<></>}
                </div>
                {current.lyrics_og==='' || !isSet(current.lyrics_og)? <span>{lng('Sem informações a mostrar')}</span>
                :
                <TabbedContent tabs={
                    [
                        {tabName:lng('Lyrics'), component:<TextContentBox removeRb={false}  content={current.lyrics_og}/>, visible:(current.lyrics_og!=='' || isSet(current.lyrics_og))},
                        {tabName:lng('Lyrics')+" - Romaji", component:<TextContentBox content={current.lyrics_romaji}/>, visible:(current.lyrics_romaji!=='' && isSet(current.lyrics_romaji))},
                        {tabName:lng('Lyrics')+" - Hiragana", component:<TextContentBox removeRb={true} content={current.lyrics_hiragana}/>, visible:(current.lyrics_hiragana!=='' && isSet(current.lyrics_hiragana))},
                        {tabName:lng('Lyrics')+" - Katakana", component:<TextContentBox removeRb={true}  content={current.lyrics_katakana}/>, visible:(current.lyrics_hiragana!=='' && isSet(current.lyrics_hiragana))},
                    ]}/>
                }


                </>
                :<>
                <SkeletonBlock style={{'width':'250px',height:'50px', 'marginTop':'8px'}}/>
                <SkeletonBlock style={{'width':'300px',height:'25px', 'marginTop':'8px'}}/>
                <SkeletonBlock style={{'width':'95%',height:'150px', 'marginTop':'15px'}}/>
                <SkeletonBlock style={{'width':'250px',height:'30px', 'marginTop':'15px'}}/>
                <SkeletonBlock style={{'width':'350px',height:'30px', 'marginTop':'15px'}}/>
                </>
                }
                </div>
          </div>
          
          <div className="naveg" data-uk-sticky="offset: 0">
            <div className = "uk-flex uk-flex-row"> 
            <SubNavigation items={tabs}/> 
            {!isMobile.any?
            <button aria-label={lng('MAB por MaxBrasi')} className="link-button tinylink">{lng('MAB por MaxBrasi')}</button>
            :<></>}
            </div>
            {isMobile.any?
            <button aria-label={lng('MAB por MaxBrasi')} className="link-button tinylink">{lng('MAB por MaxBrasi')}</button>
            :<></>}
          </div>

          <div className="authortag">
                    </div>
          {//!isMobile.any?
          //:<></>
        }
          
          
          <Route render={({ location }) => {
            const { pathname, key } = location;
            return (
              <div style={{position:'relative'}}>
                <CSSTransition2
                  in={true}
                  key={key}
                  classNames="switch-node"
                  timeout={{enter: 750, exit: 0}}
                >
                  <div>
                  <Switch>
                    <Route path={'/'+lng('music')+'/:aid/:aname'} exact={true}>
                      <MusicGeralView current={current}/>
                    </Route>
                    <Route path="*" render={() => <Erro404 />} />
                  </Switch>
                  </div>
                </CSSTransition2>
              </div>
          )
        }}/>

        </div>
        </div>
      );

}
}

export default Music;
